export default "__VITE_ASSET__2128a484__"